import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  Tooltip,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';

export type ButtonPropsColorOverrides = MuiButtonProps['color'];
export type ButtonPropsTypeOverrides = MuiButtonProps['type'];
export type ButtonPropsVariantOverrides = MuiButtonProps['variant'];

interface ButtonProps {
  id?: string;
  children: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: ButtonPropsVariantOverrides;
  type?: ButtonPropsTypeOverrides;
  color?: ButtonPropsColorOverrides;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  tooltip?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  isAddButton?: boolean;
  size?: 'small' | 'medium' | 'large';
  name?: string;
}

const Button = ({
  id,
  children,
  onClick,
  variant = 'contained',
  type = 'button',
  color,
  disabled,
  sx,
  tooltip = '',
  startIcon,
  isAddButton = false,
  endIcon,
  size = 'medium',
  name,
}: ButtonProps) => {
  const { t } = useTranslation();

  const getStartIcon = () => {
    if (color === 'error') {
      return <CloseIcon />;
    }
    if (type === 'submit') {
      return <CheckIcon />;
    } else if (isAddButton) {
      return <AddIcon />;
    }
    return startIcon;
  };

  return (
    <Tooltip title={t(tooltip)}>
      <span>
        <MuiButton
          id={id}
          disabled={disabled}
          variant={variant}
          onClick={onClick}
          color={color}
          type={type}
          sx={sx}
          startIcon={getStartIcon()}
          endIcon={endIcon}
          size={size}
          name={name}
        >
          {children}
        </MuiButton>
      </span>
    </Tooltip>
  );
};

export default Button;
